"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DefaultOwnerDetailsDisplaySettings = void 0;
const DefaultOwnerDetailsDisplaySettings = exports.DefaultOwnerDetailsDisplaySettings = {
  heading: 'About you',
  headingReadonly: 'Confirm your details',
  accordionBehaviour: true,
  showMembershipField: true,
  showPromoCodeField: true,
  showName: true,
  showBirthdate: true,
  showPostCode: true,
  ownerBirthdateInput: {
    name: 'ownerBirthdateInput',
    label: 'Your date of birth is...',
    labelTooltip: null,
    placeholder: 'dd/mm/yyyy',
    validation: {
      required: 'Please enter your date of birth.'
    }
  },
  ownerEmailInput: {
    name: 'ownerEmailInput',
    label: 'Your email address is...',
    labelTooltip: 'By providing your email address you consent to receiving communications in relation to this quote.',
    placeholder: 'Email address',
    validation: {
      required: 'Please enter your email address.'
    }
  },
  ownerNameInput: {
    name: 'ownerNameInput',
    label: 'Your name is...',
    placeholder: 'Enter name',
    validation: {
      required: 'Please enter your full name.'
    }
  },
  ownerPostCodeInput: {
    name: 'ownerPostCodeInput',
    label: 'Your postcode is...',
    placeholder: 'Enter postcode',
    validation: {
      required: 'Please enter your postcode.'
    }
  },
  ownerMembershipRadios: {
    name: 'ownerMembershipRadios',
    groupLabel: 'Do you have a member number?',
    radioInputs: [{
      label: 'Yes',
      value: 'yes'
    }, {
      label: 'No',
      value: 'no'
    }]
  },
  ownerMemberNumberInput: {
    name: 'ownerMemberNumberInput',
    label: 'Please enter your member number',
    placeholder: 'Enter member number'
  },
  ownerPromoCodeInput: {
    name: 'ownerPromoCodeInput',
    label: 'Do you have a promo code?',
    placeholder: 'Enter code'
  }
};
var _default = exports.default = {
  DefaultOwnerDetailsDisplaySettings
};